import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicInput } from 'core/components';
import { translate } from 'core/utils';

const DescriptionTemplate = ({
	modalParams: {
		data: { descriptionForm },
	},
}) => {
	return (
		<section>
			<form className="form" onSubmit={descriptionForm.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{translate('DESCRIPTIONMODAL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicInput field={descriptionForm.$('description')} />
					{descriptionForm.error && (
						<p className="type--color--warning spc--bottom--sml">{translate(descriptionForm.error)}</p>
					)}
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{translate('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(DescriptionTemplate);
